import ConfirmationModal from '@/components/ui-kit/confirmation-modal';
import { Dialog } from '@/components/ui-kit/dialog';
import { showErrorToast, showSuccessToast } from '@/hooks/use-toast';
import { isErrorWithErrors } from '@/modules/gpt-chats/utils/error';

import { useDeleteToolApiAction } from '@/modules/gpt-chats/hooks/use-tools';
import { useTranslation } from 'react-i18next';

type DeleteActionModalProps = {
  toolId: string;
  actionId: string;
  open: boolean;
  onOpenChange: (value: boolean) => void;
  isBlocksTool?: boolean;
};

export const DeleteActionModal = ({
  toolId,
  actionId,
  open,
  onOpenChange,
  isBlocksTool,
}: DeleteActionModalProps) => {
  const { mutateAsync } = useDeleteToolApiAction();
  const { t } = useTranslation();

  const confirmHandler = async () => {
    try {
      if (!toolId || !actionId) {
        showErrorToast({ errors: t('SOMETHING_WENT_WRONG') });
        return onOpenChange(false);
      }

      const res = await mutateAsync({ toolId, actionId, isBlocksTool });

      if (!res?.is_success) {
        return showErrorToast({ errors: (res as any).error ?? (res as any).detail });
      }

      showSuccessToast({ description: t('ACTION_DELETED_SUCCESSFULLY') });
      onOpenChange(false);
    } catch (error) {
      if (isErrorWithErrors(error)) {
        return showErrorToast({ errors: error.errors });
      }
      return showErrorToast({ errors: t('SOMETHING_WENT_WRONG') });
    }
  };

  const handleOpenChange = (value: boolean) => {
    if (!value) {
      onOpenChange(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={handleOpenChange}>
      <ConfirmationModal
        data={{
          dialogTitle: t('DELETE_ACTION_TITLE'),
          dialogSubtitle: t('DELETE_ACTION_SUBTITLE'),
        }}
        onConfirm={confirmHandler}
        onCancel={() => onOpenChange(false)}
      />
    </Dialog>
  );
};
